import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect, useState } from "react";
import { Button, DialogContent } from "@mui/material";

export default function BuisyIndator({
  open,
  text,
  longLoadingText,
  longLoadingCallback,
  timeout = 10 * 1000 /* 10 seconds */,
}) {
  const [longLoading, setLongLoading] = useState(false);
  useEffect(() => {
    let ttimeout = 0;
    if (open && longLoadingText) {
      ttimeout = setTimeout(() => {
        setLongLoading(true);
      }, timeout);
    }
    return () => {
      if (ttimeout) {
        window.clearTimeout(ttimeout);
      }
      setLongLoading(false);
    };
  }, [longLoadingText, open]);
  return (
    <Modal
      open={!!open}
      onClose={() => {
        /* just do not close on its own */
      }}
    >
      <div style={{ height: 0, width: 0 }} tabIndex={-1}>
        <div
          style={{
            width: "350px",
            background: "#FFF",
            position: "absolute",
            top: "50%",
            transform: "translate(-50%, -50%)",
            left: "50%",
            maxWidth: "90%",
            padding: 20,
            textAlign: "center",
            overflow: "auto",
            maxHeight: "90%",
          }}
        >
          <div>{text}</div>
          <div style={{ marginTop: 20, width: "100%", textAlign: "center" }}>
            <CircularProgress />
          </div>
          {longLoading && (
            <Button onClick={longLoadingCallback}>{longLoadingText}</Button>
          )}
        </div>
      </div>
    </Modal>
  );
}
